function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M128 448V272h256v176H128zm256-208H128V64h256v176zM96 448H64c-17.7 0-32-14.3-32-32v-48h64v80zM32 272h64v64H32v-64zm64-96v64H32v-64h64zm0-112v80H32V96c0-17.7 14.3-32 32-32h32zm320 272v-64h64v64h-64zm0 112v-80h64v48c0 17.7-14.3 32-32 32h-32zm0-272h64v64h-64v-64zm64-80v48h-64V64h32c17.7 0 32 14.3 32 32zm-32-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64z"
});

var SvgFilm = function SvgFilm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, props), _ref);
};

export default SvgFilm;